export const CameraModeDefinitions = [
  {
    value: "activeMode",
    details: "Xirgocam is on and actively recording to local storage. Active mode occurs when the vehicle is either turned on, or a bump is caused to the vehicle. Xirgocam will automatically transition from activeMode to guardMode some time after the vehicle is parked"
  },
  {
    value: "guardMode",
    details: "Xirgocam is powered on, but not actively recording.  Xirgocam is in a lower power mode, recording is suspended, and the screen is off.  The green LED beacon is flashing on top of the camera. Xirgocam will automatically change from guard mode to active mode when bumped"
  }
]